import { createContext, useContext } from "react";

interface PermissionContext {
  // employees: Employee[];
}

export const PermissionContext = createContext<PermissionContext | undefined>(
  undefined,
);

export const usePermission = () => {
  const context = useContext(PermissionContext);
  if (context === undefined) {
    throw new Error("usePermission must be used within a PermissionProvider");
  }

  return context;
};
